<mat-toolbar color="primary">
  <mat-toolbar-row class="container">
    <span>{{ 'pages.decision-tables.all-decision-table.component.new-decision-table' | translate}}</span>
    <span class="modal-toolbar-spacer"></span>
    <button mat-icon-button class="ml-auto close-toolbar-btn" (click)="!loading ? closeDialogue() : ''"
      [matTooltip]="'generic.buttons.close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>

@if (loading) {
  <div class="row">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>
}

<div class="container my-5">
  <mat-card class="login-card">
    <mat-card-content>
      <form (ngSubmit)="onSubmit()">
        <mat-form-field class="full-width">
          <mat-label>{{ "generic.title" | translate }}</mat-label>
          <input matInput [(ngModel)]="dataModel.title" name="title" required>
        </mat-form-field>

        <mat-form-field class="full-width">
          <mat-label>{{ "generic.description" | translate }}</mat-label>
          <textarea matInput [(ngModel)]="dataModel.description" name="description"></textarea>
        </mat-form-field>

        <mat-form-field class="full-width">
          <mat-label>{{ "projects.fields.obiettivi" | translate }}</mat-label>
          <textarea matInput [(ngModel)]="dataModel.obiettivi" name="obiettivi"></textarea>
        </mat-form-field>

        <mat-form-field class="full-width">
          <mat-label>{{ "projects.fields.contesto_clinico_scientifico" | translate }}</mat-label>
          <textarea matInput [(ngModel)]="dataModel.contesto_clinico_scientifico" name="contesto_clinico_scientifico"></textarea>
        </mat-form-field>

        <mat-form-field class="full-width">
          <mat-label>{{ "projects.fields.faculty" | translate }}</mat-label>
          <textarea matInput [(ngModel)]="dataModel.faculty" name="faculty"></textarea>
        </mat-form-field>

        <mat-form-field class="full-width">
          <mat-label>{{ "projects.fields.board" | translate }}</mat-label>
          <textarea matInput [(ngModel)]="dataModel.board" name="board"></textarea>
        </mat-form-field>

        <!-- Sezione per le proprietà con select -->
        @for (property of projectProperties; track property) {
          <div class="full-width">
            <mat-form-field class="full-width">
              <mat-label>{{ property.title }}</mat-label>
              <mat-select [(ngModel)]="dataModel.propertyOptions[property.id]" name="property_{{property.id}}">
                @for (option of property.options; track option) {
                  <mat-option [value]="option.id">
                    {{ option.title }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }

        <div class="row justify-content-center my-3">
          <button mat-stroked-button class="text-dark-purple border-purple mr-2" [disabled]="loading" (click)="!loading ? closeDialogue() : ''">{{"generic.buttons.cancel-and-back" | translate}}</button>
          <button [disabled]="loading" mat-raised-button color="primary" type="submit">{{"generic.send" | translate}}</button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
